import { Tooltip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useRef } from "react";
import SendIcon from "@mui/icons-material/Send";
import { useContentSetting } from "../../Hooks/ContentSetting";
import { isRTL } from "../../utils/classRoomUtils";
import logger from "../../utils/logger";
import AppLoader from "../GeneralComponents/AppLoader";

export default function SpeechRecognition(props) {
  const {
    handleSubmit,
    isSubmitting,
    setIsSubmitting,
    setMessageText,
    setIsSpeaking,
    messageText,
  } = props;
  const textareaRef = useRef(null);
  const recognitionRef = useRef(null);
  const { userInfo } = useContentSetting();
  const { country_lang, language } = userInfo.user_region;

  const handleSpeech = async () => {
    recognitionRef.current = new (window.SpeechRecognition ||
      window.webkitSpeechRecognition)();
    recognitionRef.current.lang = country_lang;
    recognitionRef.current.interimResults = true;
    recognitionRef.current.continuous = true;

    recognitionRef.current.onresult = (event) => {
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const transcript = event.results[i][0].transcript;
        const confidence = event.results[i][0].confidence;
        if (confidence < 0.3) {
          continue;
        }
        if (event.results[i].isFinal) {
          setMessageText((prevText) => prevText + transcript);
        }
      }
    };

    recognitionRef.current.onerror = (event) => {
      logger.error("Recognition error:", event.error);
    };

    recognitionRef.current.start();
  };

  const handleCancelSpeech = () => {
    setIsSpeaking(false);
  };

  const handleSend = () => {
    recognitionRef.current.stop();
    setIsSubmitting(true);
    handleSubmit();
  };

  const handleStoped = () => {
    recognitionRef.current.stop();
    setMessageText("");
    setIsSpeaking(false);
  };

  useEffect(() => {
    setMessageText("");
    handleSpeech();
    return () => handleStoped();
  }, []);

  useEffect(() => {
    if (!textareaRef.current) return;
    const textarea = textareaRef.current;
    textarea.style.height = "auto";
    const rowHeight = 20;
    const maxHeight = rowHeight * 5;
    const newHeight = Math.min(textarea.scrollHeight, maxHeight);
    textarea.style.height = `${newHeight}px`;
    textarea.scrollTop = textarea.scrollHeight;
  }, [messageText]);

  return (
    <div className="d-flex w-100 p-2 align-items-center">
      <div
        className={`recognition-input-box ps-2 ${
          isRTL(language) ? "rtl-direction" : ""
        }`}
      >
        <div className="stop-recording">
          {isRTL(language) ? (
            <>
              {isSubmitting ? (
                <div className="message-send-icon">
                  <AppLoader pixelSize={20} />
                </div>
              ) : (
                <Tooltip title="Send">
                  <div className="message-send-icon" onClick={handleSend}>
                    <SendIcon />
                  </div>
                </Tooltip>
              )}
            </>
          ) : (
            <Tooltip title="Cancel">
              <ClearIcon onClick={handleCancelSpeech} className="ms-0" />
            </Tooltip>
          )}
        </div>
        <textarea
          ref={textareaRef}
          value={messageText}
          dir={isRTL(language) ? "rtl" : "ltr"}
          onChange={(e) => setMessageText(e.target.value)}
          style={{
            textAlign: isRTL(language) ? "right" : "left",
            direction: isRTL(language) ? "rtl" : "ltr",
            resize: "none",
            overflowY: "auto",
            minHeight: "1.5em",
            lineHeight: "20px",
            transition: "height 0.2s ease",
          }}
          className={`translated-language-${language}`}
          rows={5}
        />
        {isRTL(language) ? (
          <Tooltip title="Cancel">
            <ClearIcon onClick={handleCancelSpeech} className="ms-0" />
          </Tooltip>
        ) : (
          <>
            {isSubmitting ? (
              <div className="message-send-icon">
                <AppLoader pixelSize={20} />
              </div>
            ) : (
              <Tooltip title="Send">
                <div className="message-send-icon" onClick={handleSend}>
                  <SendIcon />
                </div>
              </Tooltip>
            )}
          </>
        )}
      </div>
    </div>
  );
}
